(function() {
    // Change based on items.
    var mugVariantId = 43048170291379;
    var packetVariantId = 40256814514355;

    /**
     * Fix label text.
     * 
     * @param {*} el 
     */
    function fixLabel(el) {
        el.innerHTML = el.innerHTML.replace(/&lt;br&gt;/, "<br>");
    }

    /**
     * Add 1 item to the cart. Ensure it has a quantity of 1.
     * 
     * @param {*} variantId 
     */
    function addToCart(variantId) {
        var formData = {
            'items': [
                {
                    'id': variantId,
                    'quantity': 1,
                }
            ]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            return response.json();
        })
        .then((data) => {
            var key = null;
            console.log('data', data);
            for (var lineItem of data.items) {
                console.log('lineItem', lineItem);
                if (lineItem.variant_id === variantId) {
                    key = lineItem.key;
                }
            }

            if (key)  {
                var updateFormData = {
                    'id': key,
                    'quantity': 1,
                };
                fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(updateFormData)
                })
                .then(response => {
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    window._prizeOnWin = function (obj) {
        // Fix up prize text.
        var prizeText = document.querySelector('.spps-coupon-label div');
        fixLabel(prizeText);

        // Perform action based on which prize was won.
        var couponName = obj.couponName;
        if (couponName === "Free Gift") {
            addToCart(mugVariantId);
        } else if (couponName == "Free Packet Pouch") {
            addToCart(packetVariantId);
        }
    };

    window._prizeOnShow = function() {
        var slices = document.querySelectorAll(".spps-wh-tc");
        slices.forEach(fixLabel);
    };
}());
